// src/components/Testimonials/Testimonials.tsx
import React from 'react';
import './Testimonials.css';

interface Testimonial {
  rating: string;
  text: string;
  author: string;
}

const Testimonials: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      rating: '⭐⭐⭐⭐⭐',
      text: 'The birth chart reading was incredibly accurate and insightful. It helped me understand patterns in my life that I never recognized before. Highly recommend!',
      author: 'Sarah M.'
    },
    {
      rating: '⭐⭐⭐⭐⭐',
      text: 'The compatibility reading for my partner and me was eye-opening. We learned so much about our relationship dynamics and how to work with our differences.',
      author: 'Michael & Lisa'
    },
    {
      rating: '⭐⭐⭐⭐⭐',
      text: 'Perfect timing for my career change! The astrological guidance helped me make decisions with confidence during a major life transition.',
      author: 'David L.'
    }
  ];

  return (
    <section className="testimonials">
      <div className="container">
        <h2>What My Clients Say</h2>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars-rating">{testimonial.rating}</div>
              <p>"{testimonial.text}"</p>
              <div className="testimonial-author">- {testimonial.author}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;